import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import handleupdateEsim from '../../../../services/apollo/func/handle/handleUpdateEsim';

export const getSchema = () => {
  const schema = yup.object().shape({
    eID: yup.string().trim().required(''),
    status: yup.object().shape({}).required(''),
    licenseName: yup.object().shape()
      .when('status', {
        is: value => !value?.value,
        then: yup.object().shape({}).required(''),
        otherwise: yup.object().shape({}).nullable(),
      }),
    compatibleBrand: yup.string().trim().nullable(''),
    compatibleModel: yup.string().trim().nullable(''),
  });
  return schema;
};

export const getForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    eID: '',
    status: undefined,
    licenseName: undefined,
    compatibleBrand: '',
    compatibleModel: '',
  },
  resolver: yupResolver(schema),
});
export const updateCard = async (payload, eId) => {
  try {
    const license = payload.find(value => value.column === 'license_id');
    const status = payload.find(value => value.column === 'status');
    const brand = payload.find(value => value.column === 'compatible_brand');
    const model = payload.find(value => value.column === 'compatible_model');
    const input = {
      esimId: eId,
      licenseId: license ? license.licenseAfter.id : undefined,
      isBlocked: status ? status.valueAfter : undefined,
      compatibleBrand: brand ? brand.valueAfter.trim() : undefined,
      compatibleModel: model ? model.valueAfter.trim() : undefined,
    };
    const updatedCard = await handleupdateEsim({ input });
    return updatedCard;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};
